import { Injectable, Pipe, OnInit, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, startWith, delay } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Product } from '../classes/product';
import { ProductoServiceService } from '../../home/services/producto-service.service';
import { json } from 'stream/consumers';
import { AuthServiceService } from '../../pages/account/login/services/auth-service.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';


const state = {
  products: JSON.parse(localStorage['products'] || '[]'),
  wishlist: JSON.parse(localStorage['wishlistItems'] || '[]'),
  compare: JSON.parse(localStorage['compareItems'] || '[]'),
  cart: JSON.parse(sessionStorage['cartItems'] || '[]'),
  menu: JSON.parse(sessionStorage['menu'] || '[]')
}

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  public Currency = { name: 'Dollar', currency: 'USD', price: 1 } // Default Currency
  public OpenCart: boolean = false;
  public Products;
  private cartSubject = new BehaviorSubject<any[]>(state.cart);
  public cart$ = this.cartSubject.asObservable();
  private productsSubject = new BehaviorSubject<Product[]>([]);
  private productsRecoSubject = new BehaviorSubject<Product[]>([]);
  private productsPromoSubject = new BehaviorSubject<Product[]>([]);
  private productsTendenciaSubject = new BehaviorSubject<Product[]>([]);
  private menuSubject = new BehaviorSubject<Product[]>([]);
  public products$ = this.productsSubject.asObservable();
  public menu$ = this.menuSubject.asObservable();
  public productsReco$ = this.productsRecoSubject.asObservable();
  public productsPromo$ = this.productsPromoSubject.asObservable();
  public productsTendencia$ = this.productsTendenciaSubject.asObservable();


  private facturaData = new Subject<any>();
  public facturaData$ = this.facturaData.asObservable();

  public usuario;
  private colorSubject = new BehaviorSubject<Array<string>>([]);
  private brandSubject = new BehaviorSubject<Array<string>>([]);
  private sizeSubject = new BehaviorSubject<Array<string>>([]);
  private stringSearchSubject = new BehaviorSubject<String>('');
  private priceSubject = new BehaviorSubject<any>({});

  $modalLogin = new EventEmitter<any>();
  $modalRegister = new EventEmitter<any>();
  $modalFinvero = new EventEmitter<any>();
  $modalFacturaInvitado = new EventEmitter<any>();
  $guestUser = new EventEmitter<any>();
  $modalCodigo = new EventEmitter<any>();

  constructor(private http: HttpClient,
    private authService: AuthServiceService, private router: Router,
    private toastrService: ToastrService, private productService: ProductoServiceService) {
    this.loadProducts();
    this.loadMenu();
  }

  ngOnInit() {
  }

  /*
    ---------------------------------------------
    ---------------  Product  -------------------
    ---------------------------------------------
  */

  // fulfitMenu() {
  //   this.productoService.fulfilMenu().subscribe(
  //     (response) => {
  //       console.log(response);
  //     }
  //   )
  // }

  // Product
  private loadProducts() {
    /*  this.Products = this.http.get<Product[]>('assets/data/products.json').pipe(map(data => data));
       this.Products.subscribe(next => { localStorage['products'] = JSON.stringify(next) });
       return this.Products = this.Products.pipe(startWith(JSON.parse(localStorage['products'] || '[]')));
   
   */


    const storedProducts = JSON.parse(localStorage.getItem('products') || '[]');
    this.productsSubject.next(storedProducts);

    this.productService.obtenerProductos().subscribe(
      (data) => {
        localStorage.setItem('products', JSON.stringify(data.productos));

        this.productsSubject.next(data.productos);
        this.productsPromoSubject.next(data.productosPromociones);
        this.productsRecoSubject.next(data.productosRecomendados);
        this.productsTendenciaSubject.next(data.productosMasVendidos);
      },
      (error) => {
        console.error('Error al obtener productos del servicio', error);
      }
    );
  }

  private loadMenu() {
    const storedMenu = JSON.parse(localStorage.getItem('menu') || '{}');
    this.menuSubject.next(storedMenu); // Emitir menú desde localStorage si existe

    this.productService.fulfilMenu().subscribe(
      (response) => {
        // Guardar TODO el objeto en localStorage
        localStorage.setItem('menu', JSON.stringify(response));

        // Emitir por BehaviorSubject
        this.menuSubject.next(response);
      },
      (error) => {
        console.error('Error al obtener el menú del servicio', error);
      }
    );
  }


  //   const storedProducts = JSON.parse(localStorage.getItem('products') || '[]');
  //   this.productsSubject.next(storedProducts);

  //  this.productService.obtenerProductos().subscribe(data => {
  //     localStorage.setItem('products', JSON.stringify(data));
  //     this.productsSubject.next(data.productos);
  //   });
  // }

  // Get Products
  public get getProducts(): Observable<Product[]> {
    return this.productsSubject;
  }

  // Get Products By Slug
  public getProductBySlug(slug: string,sku:string): Observable<Product> {
    return this.productsSubject.pipe(map(items => {
      return items.find((item: any) => {
        return item.title.replace(' ', '-') === slug && item.sku === sku;
      });
    }));
  }

  // fulfitMenu() {
  //   this.productoService.fulfilMenu().subscribe(
  //     (response) => {
  //       console.log(response);
  //     }
  //   )
  // }

  /*
    ---------------------------------------------
    ---------------  Wish List  -----------------
    ---------------------------------------------
  */

  // Get Wishlist Items
  public get wishlistItems(): Observable<Product[]> {
    const itemsStream = new Observable(observer => {
      observer.next(state.wishlist);
      observer.complete();
    });
    return <Observable<Product[]>>itemsStream;
  }

  // Add to Wishlist
  public addToWishlist(product): any {
    const wishlistItem = state.wishlist.find(item => item.sku === product.sku)
    if (!wishlistItem) {
      state.wishlist.push({
        ...product
      })
    }
    this.toastrService.success('El producto ha sido agregado en la lista de deseos.');
    localStorage.setItem("wishlistItems", JSON.stringify(state.wishlist));
    return true
  }

  // Remove Wishlist items
  public removeWishlistItem(product: Product): any {
    const index = state.wishlist.indexOf(product);
    state.wishlist.splice(index, 1);
    localStorage.setItem("wishlistItems", JSON.stringify(state.wishlist));
    return true
  }

  /*
    ---------------------------------------------
    -------------  Compare Product  -------------
    ---------------------------------------------
  */

  // Get Compare Items
  public get compareItems(): Observable<Product[]> {
    const itemsStream = new Observable(observer => {
      observer.next(state.compare);
      observer.complete();
    });
    return <Observable<Product[]>>itemsStream;
  }

  // Add to Compare
  public addToCompare(product): any {

    const compareItem = state.compare.find(item => item.sku === product.sku)
    if (!compareItem) {
      state.compare.push({
        ...product
      })
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth", // Para un desplazamiento suave
    });
    this.router.navigateByUrl('/shop/compare');
    this.toastrService.success('Se agregó producto para comparación.');
    localStorage.setItem("compareItems", JSON.stringify(state.compare));
    return true
  }

  // Remove Compare items
  public removeCompareItem(product: Product): any {
    const index = state.compare.indexOf(product);
    state.compare.splice(index, 1);
    localStorage.setItem("compareItems", JSON.stringify(state.compare));
    return true
  }

  /*
    ---------------------------------------------
    -----------------  Cart  --------------------
    ---------------------------------------------
  */

  // Get Cart Items
  public get cartItems(): Observable<Product[]> {
    const itemsStream = new Observable(observer => {
      observer.next(state.cart);
      observer.complete();
    });
    return <Observable<Product[]>>itemsStream;
  }

  // Add to Cart
  public addToCart(product): any {
    const cartItem = state.cart.find(item => item.sku === product.sku);
    const qty = product.quantity ? product.quantity : 1;
    const items = cartItem ? cartItem : product;
    const stock = this.calculateStockCounts(items, qty);

    if (!stock) return false

    if (product.idProductoProveedor === 1) {
      this.usuario = this.authService.getUser();
      if (this.usuario) {
        this.productService.getReservaProdCarrito(product.sku, qty).subscribe(
          (response) => {
            if (response) {
              if (cartItem) {
                cartItem.quantity += qty
              } else {
                state.cart.push({
                  ...JSON.parse(JSON.stringify(product)),
                  quantity: qty
                })
              }
              // this.router.navigate(['/shop/cart']);
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'No hay unidades suficientes para agregar al carrito',
                confirmButtonText: 'Cerrar',
                showCloseButton: true
              }).then((result) => {
                // Redirigir al home sin importar cómo cerró la alerta
                // this.router.navigate(['/']);
              });
            }
            sessionStorage.setItem("cartItems", JSON.stringify(state.cart));
            this.cartSubject.next([...state.cart]);
          })
      } else {
        this.productService.getReservaProdCarritoInvitado(product.sku, qty).subscribe(
          (response) => {
            if (response) {
              if (cartItem) {
                cartItem.quantity += qty
              } else {
                state.cart.push({
                  ...JSON.parse(JSON.stringify(product)),
                  quantity: qty
                })
              }
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'No hay unidades suficiantes para agregar al carrito',
                confirmButtonText: 'Cerrar',
                showCloseButton: true
              }).then((result) => {
                // Redirigir al home sin importar cómo cerró la alerta
                //this.router.navigate(['/']);
              });
            }
            sessionStorage.setItem("cartItems", JSON.stringify(state.cart));
            this.cartSubject.next([...state.cart]);
          });
      }
    } else {
      if (cartItem) {
        cartItem.quantity += qty
      } else {
        state.cart.push({
          ...JSON.parse(JSON.stringify(product)),
          quantity: qty
        })
      }
    }
    this.OpenCart = true; // If we use cart variation modal
    sessionStorage.setItem("cartItems", JSON.stringify(state.cart));
    this.cartSubject.next([...state.cart]); // Emitir el nuevo estado del carrito
    if (this.authService.getUser() !== null && this.authService.getUser() !== undefined) {

      this.cartItems.subscribe((response) => {

        let data = {
          cartItems: response
        };
        this.productService.carritoOlvidado(data).subscribe((response) => {
        });
      });
    }
    return true;
  }



  // Update Cart Quantity
  public updateCartQuantity(product: Product, quantity: number): Product | boolean {

    return state.cart.find((item, index) => {
      if (item.id === product.id) {
        const newQty = item.quantity + quantity;
        const stock = this.calculateStockCounts(item, quantity);

        if (newQty !== 0 && stock) {
          state.cart[index].quantity = newQty;

          if (!product.esFulfix) {
            const isIncrement = quantity > 0;
            const absQty = Math.abs(quantity);

            if (isIncrement) {
              if (this.usuario) {
                this.productService.getReservaProdCarrito(product.sku, quantity).subscribe(
                  (response) =>
                  {});
              } else {
                this.productService.getReservaProdCarritoInvitado(product.sku, quantity).subscribe(
                  (response) => {}
                );
              }
            } else {
              if (this.usuario) {
                this.productService.getLiberarProdCarrito(product.sku, absQty).subscribe(
                  (response) => {}
                );
              } else {
                this.productService.getLiberarProdCarritoInvitado(product.sku, absQty).subscribe(
                  (response) => {}
                );
              }
            }
          }


          sessionStorage.setItem("cartItems", JSON.stringify(state.cart));
          return true;
        }
      }
    });
  }


  // Calculate Stock Counts
  public calculateStockCounts(product, quantity) {
    const qty = product.quantity + quantity
    const stock = product.variants.find(x => x.id == product.id)
    if (stock < qty || stock == 0) {
      this.toastrService.error('You can not add more items than available. In stock ' + stock + ' items.');
      return false
    }
    return true
  }

  // Remove Cart items
  public removeCartItem(product: Product): any {
    const index = state.cart.indexOf(product);
    state.cart.splice(index, 1);
    sessionStorage.setItem("cartItems", JSON.stringify(state.cart));

    if (!product.esFulfix) {
      const qty = product.quantity || 1; // usa la cantidad del producto que estaba en el carrito
      this.usuario = this.authService.getUser();

      if (this.usuario) {
        this.productService.getLiberarProdCarrito(product.sku, qty).subscribe(
          (response) => {}
        );
      } else {
        this.productService.getLiberarProdCarritoInvitado(product.sku, qty).subscribe(
          (response) =>{}
        );
      }
    }
    if (this.authService.getUser() !== null && this.authService.getUser() !== undefined) {
      this.productService.removeCarritoOlvidado(product.id).subscribe((response) => { });
    };

    return true
  }


  public removeAllCartItem(product: Product): any {
    if (state.cart.length > 2) {
      state.cart.splice(0, state.cart.length); // Elimina todos los elementos del carrito
    } else {
      const index = state.cart.indexOf(product);
      state.cart.splice(index, 1); // Elimina solo el elemento especificado
    }

    sessionStorage.setItem("cartItems", JSON.stringify(state.cart));

    if (this.authService.getUser() !== null && this.authService.getUser() !== undefined) {
      this.productService.removeCarritoOlvidado(product.id).subscribe((response) => { });
    }

    return true;
  }

  // Total amount 
  public cartTotalAmount(): Observable<number> {
    return this.cartItems.pipe(map((product: Product[]) => {
      return product.reduce((prev, curr: Product) => {
        let price = curr.price;
        if (curr.tienePromocion) {
          price = curr.priceDiscount
        }
        return (prev + price * curr.quantity) * this.Currency.price;
      }, 0);
    }));
  }

  public cartCantTotal(): Observable<number> {
    return this.cartItems.pipe(
      map((items: Product[]) => {
        return items.reduce((total, item) => total + item.quantity, 0);
      })
    );
  }
  /*
    ---------------------------------------------
    ------------  Filter Product  ---------------
    ---------------------------------------------
  */

  // Get Product Filter
  public filterProducts(filter: any): Observable<Product[]> {
    return this.productsSubject.pipe(map(product =>
      product.filter((item: Product) => {
        if (!filter.length) return true
        const Tags = filter.some((prev) => { // Match Tags
          if (item.tags) {
            if (item.tags.includes(prev)) {
              return prev
            }
          }
        })
        return Tags
      })
    ));
  }

  // Sorting Filter
  public sortProducts(products: Product[], payload: string): any {

    if (payload === 'ascending') {
      return products.sort((a, b) => {
        if (a.id < b.id) {
          return -1;
        } else if (a.id > b.id) {
          return 1;
        }
        return 0;
      })
    } else if (payload === 'a-z') {
      return products.sort((a, b) => {
        if (a.title < b.title) {
          return -1;
        } else if (a.title > b.title) {
          return 1;
        }
        return 0;
      })
    } else if (payload === 'z-a') {
      return products.sort((a, b) => {
        if (a.title > b.title) {
          return -1;
        } else if (a.title < b.title) {
          return 1;
        }
        return 0;
      })
    } else if (payload === 'low') {
      return products.sort((a, b) => {
        if (a.price < b.price) {
          return -1;
        } else if (a.price > b.price) {
          return 1;
        }
        return 0;
      })
    } else if (payload === 'high') {
      return products.sort((a, b) => {
        if (a.price > b.price) {
          return -1;
        } else if (a.price < b.price) {
          return 1;
        }
        return 0;
      })
    }
  }

  /*
    ---------------------------------------------
    ------------- Product Pagination  -----------
    ---------------------------------------------
  */
  public getPager(totalItems: number, currentPage: number = 1, pageSize: number = 12) {
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    // Paginate Range
    let paginateRange = 3;

    // ensure current page isn't out of range
    if (currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    let startPage: number, endPage: number;
    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else if (currentPage < paginateRange - 1) {
      startPage = 1;
      endPage = startPage + paginateRange - 1;
    } else {
      startPage = currentPage - 1;
      endPage = currentPage + 1;
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

  emitirBrand(brand: Array<string>) {
    this.brandSubject.next(brand);
  }

  obtenerBrand(): Observable<Array<string>> {
    return this.brandSubject.asObservable();
  }

  emitirColor(valor: Array<string>) {
    this.colorSubject.next(valor);
  }


  emitirMarca(valor: Array<string>) {
    this.brandSubject.next(valor);
  }

  obtenerColor(): Observable<Array<string>> {
    return this.colorSubject.asObservable();
  }

  emitirPrice(valor: any) {
    this.priceSubject.next(valor);
  }

  obtenerPrice(): Observable<any> {
    return this.priceSubject.asObservable();
  }

  emitirSize(valor: Array<string>) {
    this.sizeSubject.next(valor);
  }

  obtenerSize(): Observable<Array<string>> {
    return this.sizeSubject.asObservable();
  }

  emitirStringSearch(valor: String) {
    this.stringSearchSubject.next(valor);
  }

  obtenerStringSearch(): Observable<String> {
    return this.stringSearchSubject.asObservable();
  }

  emitirDataFactura(data: any) {
    this.facturaData.next(data);
  }

}
